import { render, staticRenderFns } from "./AppLocked.vue?vue&type=template&id=6f2a87ab&scoped=true&"
import script from "./AppLocked.vue?vue&type=script&lang=js&"
export * from "./AppLocked.vue?vue&type=script&lang=js&"
import style0 from "./AppLocked.vue?vue&type=style&index=0&id=6f2a87ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a87ab",
  null
  
)

export default component.exports